// NOTE: Sealy's previous hardcoded ProductGrid had a buildExternalCallout
// that rendered "In Stores Only" / "Online Exclusive–Shop Now" badges based on the
// product's in_store_only attribute. If that feature is needed again, override this
// template to pass a custom buildExternalCallout prop to ProductGridSSR.
export { Template } from "tsi-common-react/src/templates/ProductGridBlockTemplate";
